import { inject, Injectable } from '@angular/core';
import { computed } from '@angular/core';
import { OrderApiResponseStateService } from '../../../order-api-response/order-api-response-state.service';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { VoiceFlowStateService } from '../voice-flow-state.service';
import { VoicePackageSelectionData } from '../../../../../../../models/order/workflow/voice/voice-package-selection.model';


@Injectable({ providedIn: 'root' })
export class VoicePackageSelectionStateService extends BaseWorkflowStateService<VoicePackageSelectionData> {
    private orderApiResponseState: OrderApiResponseStateService = inject(OrderApiResponseStateService);
    private flowStateService = inject(VoiceFlowStateService);
    private _apiData = this.orderApiResponseState.apiData;
    protected override stateKey: string = 'voicePackageSelection';
    /** Data slice for the Voice flow */
    voiceState = this.flowStateService.state;

    /** API Data */
    apiData = computed(() => this._apiData());
    serviceAvailabilityData = this.orderApiResponseState.serviceAvailabilityData;
    customer = this.orderApiResponseState.customer;

    isPlanSelected = computed(() => !!this.state()?.selectedPlanCode);

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ voicePackageSelection: this.state() });
    }
}
